(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
	class StickyHeader extends HTMLElement {
	constructor() {
	super();
	}

	connectedCallback() {
		this.header = document.querySelector('.shopify-section-header');
		this.headerWrapper = document.querySelector('.header-wrapper');
		this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
		this.headerBounds = {};
		this.currentScrollTop = 0;
		this.preventReveal = false;
		this.predictiveSearch = this.querySelector('predictive-search');

		this.onScrollHandler = this.onScroll.bind(this);
		this.hideHeaderOnScrollUp = () => this.preventReveal = true;

		this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
		window.addEventListener('scroll', this.onScrollHandler, false);

		this.createObserver();
	}

	disconnectedCallback() {
		this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
		window.removeEventListener('scroll', this.onScrollHandler);
	}

	createObserver() {
		let observer = new IntersectionObserver((entries, observer) => {
		this.headerBounds = entries[0].intersectionRect;
		observer.disconnect();
		});

		if (this.header) {
			observer.observe(this.header);
		}
	}

	onScroll() {
	const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

	if (this.headerIsAlwaysSticky && scrollTop > this.header.offsetHeight + 1) {
		this.header.classList.add('shopify-section-header-sticky','shopify-section-header-always-sticky');
		this.header.classList.remove('color-background-3');
		this.header.style.transition = 'background var(--duration-short), transform var(--duration-default)';
	};

	if (this.headerIsAlwaysSticky && scrollTop < this.header.offsetHeight) {
		this.header.classList.remove('shopify-section-header-sticky');
		this.header.style.transition = 'background var(--duration-short)';
		if (this.header.classList.contains('color-background-1')) {
			this.header.classList.add('color-background-3');
		};
	};

	if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
		if (this.preventHide) return;
		requestAnimationFrame(this.hide.bind(this));
		} else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
		if (!this.preventReveal) {
		requestAnimationFrame(this.reveal.bind(this));
		} else {
			window.clearTimeout(this.isScrolling);

			this.isScrolling = setTimeout(() => {
			this.preventReveal = false;
			}, 66);

			requestAnimationFrame(this.hide.bind(this));
		}
		} else if (scrollTop <= this.headerBounds.top) {
		requestAnimationFrame(this.reset.bind(this));
		}

		this.currentScrollTop = scrollTop;
	}

	hide() {
		if (this.headerIsAlwaysSticky) return;
		this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
		this.closeMenuDisclosure();
	}

	reveal() {
		if (this.headerIsAlwaysSticky) return;
		this.header.classList.add('shopify-section-header-sticky', 'animate');
		this.header.classList.remove('shopify-section-header-hidden','color-background-3');
	}

	reset() {
		if (this.headerIsAlwaysSticky) return;
		this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
		if (this.header.classList.contains('color-background-1')) {
			this.header.classList.add('color-background-3');
		};
	}

	closeMenuDisclosure() {
		this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
		if (this.disclosures) {
			this.disclosures.forEach(disclosure => {
				disclosure.close(); 
			});
		}
		this.disclosureLists = this.header.querySelectorAll('.disclosure__list');
			if (this.disclosureLists) {
				this.disclosureLists.forEach(disclosureList => {
					disclosureList.setAttribute('hidden', true); 
				});
			}
		}
	}

	customElements.define('sticky-header', StickyHeader);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-items"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener(
        'change',
        debounce((event) => {
          const body = JSON.stringify({ note: event.target.value });
          fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
        }, 300)
      );
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);

      if (
        activeMedia.nodeName == 'DEFERRED-MEDIA' &&
        activeMedia.querySelector('template')?.content?.querySelector('.js-youtube')
      )
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();
})();
